<template>
  <div class="page-content">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="固件列表" name="first" class="first">
        <!-- 功能容器 -->
        <div class="function-wrap">
          <div class="left">
            <div class="left_l">
              <el-button type="primary" @click="add">新增固件</el-button>
              <el-select v-model="value" placeholder="请选择" @change="optionChange" clearable>
                <el-option
                  v-for="item in options"
                  :key="item.productKey"
                  :label="item.productName"
                  :value="item.productKey">
                </el-option>
              </el-select>
            </div>
            <div class="left_r">
              <el-input placeholder="请输入固件名称" v-model.trim="input" @keyup.13.native="handlerKeyUp" clearable>
                <el-button slot="append" icon="el-icon-search" @click="demand"></el-button>
              </el-input>
            </div>
          </div>
          <!-- 右侧刷新 -->
          <div class="right">
            <!-- <el-button icon="el-icon-refresh-right" @click="refresh"></el-button> -->
            <div>
              <i class="el-icon-refresh-right" @click="refresh"></i>
            </div>
          </div>
        </div>
        <!-- Table 表格数据 -->
        <el-table
          :header-cell-style="{background:'#eef1f6',color:'#606266'}"
          :data="tableData"
          style="width: 100%">
          <el-table-column
            prop="firmwareName"
            label="固件名称"
            width="180">
            <template slot-scope="scope">
              <span style="margin-right: 10px">{{ scope.row.firmwareName }}</span>
              <el-tooltip :content="`固件ID: ${scope.row.firmwareId}`" placement="top" effect="light">
                <span class="bubble">{{scope.row.firmwareType === 0 ? '全包' : '差包'}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="destVersion"
            label="固件版本号"
            width="180">
          </el-table-column>
          <el-table-column
            prop="productName"
            label="所属产品">
          </el-table-column>
          <el-table-column
            prop="module"
            label="自定义模块名称">
          </el-table-column>
          <el-table-column
            prop="verifyStatus"
            label="状态">
              <template slot-scope="scope">
              <span class="tip" :style="{background:(scope.row.verifyStatus === 1 ? 'green': '#888')}"></span>
              <span style="margin-right: left">{{ scope.row.verifyStatus === 1 ? '已验证': '未验证' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="添加时间">
          </el-table-column>
          <el-table-column
            label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="tableClick('valid', scope.row)">验证固件</el-button>
              <el-button type="text" size="small" :disabled="scope.row.verifyStatus === 0" @click="tableClick('agains', scope.row)">重新验证</el-button>
              <el-tooltip content="请先验证固件，再进行升级" placement="top" effect="light" v-if="scope.row.verifyStatus === 0 ">
                <el-button type="text" size="small" :class="scope.row.verifyStatus === 1  ? '' : 'stop' ">批量升级</el-button>
              </el-tooltip>
              <el-button type="text" size="small" v-else @click="tableClick('update', scope.row)">批量升级</el-button>
              <el-button type="text" size="small" @click="tableClick('view', scope.row)">查看</el-button>
              <el-button type="text" size="small" @click="tableClick('delete', scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页管理 -->
        <Paging :total="total" @changePage="changePage"/>
        <!-- VerifyFirmware组件 -->
        <VerifyFirmware
        v-if="verifyDialogFlag"
        :verifyDialogFlag="verifyDialogFlag"
        :rows="rows"
        :date="date"
        ref="verifyFirm"
        @reflash='reflash'
        @closeVerifyDialog="verifyDialogFlag = false"></VerifyFirmware>
        <!-- BatchUpGrade组件 -->
        <BatchUpGrade
        v-if="BatchUpGradeDialogFlag"
        :BatchUpGradeDialogFlag="BatchUpGradeDialogFlag"
        @closeBatchDialog="BatchUpGradeDialogFlag = false"
        :rows="rows"
        :date="udate"
        ref="batchUpgrading"></BatchUpGrade>
        <!-- 新增固件组件 -->
        <AddFirmware v-show="dialogFormVisible" :dialogFormVisible="dialogFormVisible" :options="options" @closeDialog="closeDialog"/>
      </el-tab-pane>
      <!-- <el-tab-pane label="版本分布" name="second" class="first">版本分布</el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
import { mixin } from '@/mixins/mixin.js'
import { dataFormat } from '@/utils/index'
import { getFirmwareList, deleteFirware, getPoductList } from '@/api/productControl'
import Paging from '@/components/paging'
import VerifyFirmware from '@/components/VerifyFirmwareDialog/index.vue'
import BatchUpGrade from '@/components/VerifyFirmwareDialog/batchUpGradings.vue'
import AddFirmware from '@/components/firmwareUpdate/addFirmware'
export default {
  mixins: [mixin],
  data () {
    return {
      // 分页功能
      total: 0, // 到时候从后台获取
      listLoading: false, // 根据loading来进行显示/隐藏
      listQuery: {
        page: 1,
        limit: 10
      },
      activeName: 'first',
      options: [], // 选择框内容
      value: '', // 选择框选中后内容
      input: '',
      tableData: [],
      dialogFormVisible: false, // dialog蒙版开关
      params: {},
      rows: {}, // 传给组件的数据
      againData: {},
      date: Date.parse(new Date()),
      udate: Date.parse(new Date()), // 批量升级组件
      verifyDialogFlag: false,
      BatchUpGradeDialogFlag: false
    }
  },
  components: {
    VerifyFirmware,
    BatchUpGrade,
    AddFirmware,
    Paging
  },
  created () {
  },
  mounted () {
    this.getList()
    this.getPoductLists()
  },
  methods: {
    reflash () {
      this.getList()
    },
    // 获取列表
    getList () {
      this.params.firmwareName = this.input
      if (this.params.productKey === '') delete this.params.productKey
      if (this.params.firmwareName === '') delete this.params.firmwareName
      this.params.pageNum = this.listQuery.page
      this.params.pageSize = this.listQuery.limit
      const params = {
        params: this.params
      }
      if (JSON.stringify(params.params) === '{}') delete params.params
      getFirmwareList(params).then((res) => {
        if (res.data.code === 200 && res.data.data) {
          this.tableData = res.data.data.list
          this.listLoading = false
          this.total = res.data.data.total
          this.tableData.forEach((item) => {
            item.createTime = dataFormat(item.createTime)
          })
        } else if (Boolean(res.data.data) === false) {
          this.tableData = []
          this.total = res.data.data.total
        }
        if (this.total === 0) this.listLoading = true
      })
    },
    // 获取产品列表
    getPoductLists () {
      getPoductList()
        .then(e => {
          /* e.data.data.forEach(item => {
            delete item.productId
          }) */
          this.options = e.data.data
          console.log('this.options', this.options)
        })
    },
    // enter 键事件
    handlerKeyUp (e) {
      if (e.keyCode === 13) {
        this.demand()
      }
    },
    // 根据固件名查询列表
    demand () {
      this.listQuery.page = 1
      this.getList()
    },
    // 刷新按钮事件
    refresh () {
      this.listQuery.page = 1
      this.getList()
    },
    // table功能按钮
    tableClick (val, row) {
      switch (val) {
        case 'valid':
          this.rows = row
          this.date = Date.parse(new Date())
          // this.$refs.verifyFirm.dialogFormVisible = true
          this.verifyDialogFlag = true
          break
        case 'agains':
          this.againData = Object.assign({}, row)
          this.againData.agains = 'agains'
          this.rows = this.againData
          this.date = Date.parse(new Date())
          // this.$refs.verifyFirm.dialogFormVisible = true
          this.verifyDialogFlag = true
          break
        case 'update':
          this.rows = row
          this.udate = Date.parse(new Date())
          // this.$refs.batchUpgrading.dialogFormVisible = true
          this.BatchUpGradeDialogFlag = true
          break
        case 'view':
          this.$router.push({
            path: './firmwareDetail',
            query: {
              row: JSON.stringify(row)
            }
          })
          break
        case 'delete':
          this.$confirm('此操作不可逆, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            const params = {
              params: {
                firmwareId: row.firmwareId
              }
            }
            deleteFirware(params)
              .then(() => {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
                this.cutPage()
                this.getList()
              })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
          break
      }
    },
    // 分页管理
    changePage (val) {
      this.listQuery = val
      this.getList()
    },
    // 切换tabs
    handleClick (tab, event) {
      // console.log(tab, event)
    },
    // options选项改变
    optionChange (val) {
      this.listQuery.page = 1
      this.params.productKey = val
      this.getList()
    },
    // 打开dialog
    add () {
      this.dialogFormVisible = true
    },
    closeDialog (val) {
      if (val) {
        this.dialogFormVisible = false
        this.getList()
      } else {
        this.dialogFormVisible = false
      }
    }
    /* beforeAvatarUpload (event, file, fileList) {
      console.log(event)
      const loadProgress = Math.floor(event.percent) // 这就是当前上传的进度
      // 可以进行其他逻辑
      console.log(loadProgress)
    } */
  }
}
</script>
<style lang="less" scoped>
  .first{
    border:none !important;
    padding: 0 !important;
    width: 100% !important;
    height: 100% !important;
    .function-wrap{
      display: flex;
      justify-content: space-between;
      padding-bottom: 10px;
      .left{
        display: flex;
        .el-input {
          width: 300px;
          margin-left: 10px;
        }
        /deep/ .el-select{
          margin-left: 10px;
        }
      }
      .right{
        cursor: pointer;
        width: 40px;
        border: 1px solid #C0C4CC;
        text-align: center;
        line-height: 40px;
        font-size: 20px;
        color:#C0C4CC;
        border-radius: 5px;
      }
    }
    .cell{
      .bubble{
        padding: 0 8px;
        border: 1px solid skyblue !important;
        color: skyblue;
        background: rgb(255, 255, 255);
        border-radius: 10px;
        cursor: pointer;
      }
      .tip{
        height: 8px;
        width: 8px;
        border-radius: 50%;
        background: #888;
        display: inline-block;
        margin-right: 8px;
      }
    }
    /deep/ .el-table__header{
      border-top: 1px solid #EBEEF5
    }
    .stop{
      cursor: not-allowed;
      color: #c1c1c1;
    }
    /deep/ .el-form-item__label{
      width: 120px !important;
    }
    /deep/ .el-form-item__content{
      margin-left: 120px !important;
    }
    .item-items{
      /deep/ .el-form-item__content{
        margin-left: 0 !important;
      }
    }
    .el-pagination{
      margin-top: 30px;
      float: right;
    }
  }
</style>
